import { DevicesDetectionConfig } from '../models';

export const DEFAULT_DEVICES_DETECTION_CONFIG: DevicesDetectionConfig = {
  screenWidth: {
    mobile: 768,
    desktop: Number.MAX_SAFE_INTEGER
  }
};
